import { render, staticRenderFns } from "./sanctionList.vue?vue&type=template&id=2d724f84"
import script from "./sanctionList.vue?vue&type=script&lang=js"
export * from "./sanctionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports